// Postal routing details are not part of the physical destination.
export const normalizeMapsAddress = (address) =>
  address
    .replace(/\b(?:BP|CS|TSA)\s*\d+\b/gi, "")
    .replace(/\bCEDEX(?:\s+\d+)?\b/gi, "")
    .replace(/\s+/g, " ")
    .replace(/\s*,\s*/g, ", ")
    .replace(/^(?:,\s*)+|(?:,\s*)+$/g, "")
    .trim();
